<template>
  <div>
    <h2 class="content-block">Gaji List Pisah</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          :loop="loop"
          :animation-enabled="animationEnabled"
          :swipe-enabled="swipeEnabled"
          item-title-template="title"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #tDireksi> direksi </template>
          <template #tTetap> tetap </template>
          <template #tHonor>
            <DxDataGrid
              ref="gridRefHonor"
              :data-source="dataSourceHonor"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />
              <DxToolbar>
                <DxItem name="exportButton" />
              </DxToolbar>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <DxColumn
                data-field="pegawai_id"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
              >
                <DxLookup
                  :data-source="pegawaiSource"
                  value-expr="id"
                  display-expr="nik"
                />
              </DxColumn>
              <DxColumn
                data-field="pegawai_id"
                caption="Nama"
                :fixed="true"
                fixed-position="left"
              >
                <DxLookup
                  :data-source="pegawaiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="tgl_gaji"
                caption="Tgl"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
              >
              </DxColumn>
              <DxColumn data-field="golongan_id" caption="Gol.">
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="tmt_kontrak"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
              >
              </DxColumn>
              <!-- <DxColumn
                data-field="tmt_kontrak"
                caption="Masa Kerja"
                cell-template="mkTemplate"
              >
              </DxColumn> -->
              <DxColumn
                data-field="tmt_kontrak"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[0].jml"
                caption="Honor (UMK)"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[1].jml"
                caption="Kenaikan Masa Kerja"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[2].jml"
                caption="Tunj. Kesehatan"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[3].jml"
                caption="Pot. 5%"
              >
              </DxColumn>

              <DxColumn
                data-field="pegawaiGajiDetails[4].jml"
                caption="Pot. Kesehatan"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[5].jml"
                caption="Pot. BPJS TK 2%"
              >
              </DxColumn>
              <DxColumn data-field="total_diterima" caption="Total Diterima">
              </DxColumn>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
            </DxDataGrid>
          </template>
          <template #tKontrak>
            <DxDataGrid
              ref="gridRefKontrak"
              :data-source="dataSourceKontrak"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />
              <DxToolbar>
                <DxItem name="exportButton" />
              </DxToolbar>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <DxColumn
                data-field="pegawai_id"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
              >
                <DxLookup
                  :data-source="pegawaiSource"
                  value-expr="id"
                  display-expr="nik"
                />
              </DxColumn>
              <DxColumn
                data-field="pegawai_id"
                caption="Nama"
                :fixed="true"
                fixed-position="left"
              >
                <DxLookup
                  :data-source="pegawaiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="tgl_gaji"
                caption="Tgl"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
              >
              </DxColumn>
              <DxColumn data-field="golongan_id" caption="Gol.">
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="tmt_kontrak"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
              >
              </DxColumn>
              <!-- <DxColumn
                data-field="tmt_kontrak"
                caption="Masa Kerja"
                cell-template="mkTemplate"
              >
              </DxColumn> -->
              <DxColumn
                data-field="tmt_kontrak"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[0].jml"
                caption="Honor (UMK)"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[1].jml"
                caption="Kenaikan Masa Kerja"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[2].jml"
                caption="Tunj. Kesehatan"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[3].jml"
                caption="Pot. 5%"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[4].jml"
                caption="Tunj. BPJS TK"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[5].jml"
                caption="Pot. Kesehatan"
              >
              </DxColumn>
              <DxColumn
                data-field="pegawaiGajiDetails[6].jml"
                caption="Pot. BPJS TK 1.19%"
              >
              </DxColumn>
              <DxColumn data-field="total_diterima" caption="Total Diterima">
              </DxColumn>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
            </DxDataGrid>
          </template>
        </DxTabPanel>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import DxTabPanel from "devextreme-vue/tab-panel";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxToolbar,
} from "devextreme-vue/data-grid";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DateTime } from "luxon";
import _ from "lodash";
const tabSource = [
  {
    id: 1,
    text: "Direksi",
    template: "tDireksi",
  },
  {
    id: 2,
    text: "Pegawai Tetap",
    template: "tTetap",
  },
  {
    id: 3,
    text: "Pekerja Honor",
    template: "tHonor",
  },
  {
    id: 4,
    text: "Pekerja Kontrak",
    template: "tKontrak",
  },
];

function hasFilterNestedTable(str) {
  return _.includes(str, "/") || _.includes(str, "[") || _.includes(str, "]");
}

function convertDatagridFilterNested(filter) {
  /*
          filter asli yang dibuat oleh devextreme = pegawaiGajiDetails[0]/id eq 734
          yang ok adalah 
          pegawaiGajiDetails/any(s:s/
        */
  const regex = /(\(pegawaiGajiDetails\[\d+\]\/[^)]+\))/g;
  const occurrences = _.uniq(filter.match(regex));
  //biar dapat ['(pegawaiGajiDetails[0]/jml eq 23)', '(pegawaiGajiDetails[1]/jml eq 23)']
  const modifiedArr = occurrences.map((str) => {
    const modifiedString = str
      .replace(/\[\d+\]/g, "")
      .replace(
        /(pegawaiGajiDetails\/)(.+)/,
        (match, capture1, capture2) => `${capture1}any(s:s/${capture2}`
      );
    return modifiedString + ")";
  });
  occurrences.forEach((extracted, index) => {
    filter = filter.replace(extracted, modifiedArr[index]);
  });
  return filter;
}

const dataSourceHonor = new DataSource({
  store: new ODataStore({
    url: "http://127.0.0.1/odata/PegawaiGajis",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertDatagridFilterNested(e.params.$filter);
      }
    },
  }),
  expand: ["simpegPegawai", "pegawaiGajiDetails"],
  filter: ["gaji_skema_id", 1], //honor
});

const dataSourceKontrak = new DataSource({
  store: new ODataStore({
    url: "http://127.0.0.1/odata/PegawaiGajis",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      if (hasFilterNestedTable(e.params.$filter)) {
        //melakukan filter pegawaiGajiDetails
        e.params.$filter = convertDatagridFilterNested(e.params.$filter);
      }
    },
  }),
  expand: ["simpegPegawai", "pegawaiGajiDetails"],
  filter: ["gaji_skema_id", 2], //kontrak
});

export default {
  components: {
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxToolbar,
  },
  data() {
    return {
      pegawaiGajiDetailSource: new ODataStore({
        url: "http://127.0.0.1/odata/PegawaiGajiDetails",
        key: "id",
      }),
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      pegawaiSource: new ODataStore({
        url: "http://127.0.0.1/odata/SimpegPegawais",
        key: "id",
      }),
      numberingPageSize: 10,
      numberingPageNumber: 0,
      dataSourceHonor: dataSourceHonor,
      dataSourceKontrak: dataSourceKontrak,
      // currentTemplate: "tHonor",
      tabPanelIndex: 2,
      loop: true,
      animationEnabled: true,
      swipeEnabled: true,
      tabSource: tabSource,
      filterValue: "",

      oneditorpreparing: function (e) {
        if (e.dataField === "tgl_gaji") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      calculateFilterMK: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        if (selectedFilterOperation === "contains" && target == "filterRow") {
          const currentDate = DateTime.now();
          const mkDate = currentDate.minus({ years: filterValue });
          var filterExpression = [
            "year(" +
              this.dataField +
              ") ge " +
              mkDate.year +
              " and " +
              "year(" +
              this.dataField +
              ") le " +
              currentDate.year,
          ];
          return filterExpression;
        }
      },
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(" +
              column.dataField +
              ") lt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(" +
              column.dataField +
              ") gt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(" +
              column.dataField +
              ") ge " +
              bulan1 +
              " and year(" +
              column.dataField +
              ") ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(" +
              column.dataField +
              ") le " +
              bulan2 +
              " and year(" +
              column.dataField +
              ") le " +
              filterValue[1].getFullYear(),
          ];
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
    };
  },
  methods: {
    calculateDisplayMK(e) {
      const today = DateTime.local().setLocale("id");
      const date2 = DateTime.fromISO(e.tmt_kontrak);
      return Math.floor(today.diff(date2, "years").years) + " tahun";
    },
    formatMasaKerja(e) {
      const today = DateTime.local().setLocale("id");
      const date2 = DateTime.fromISO(e);

      return Math.floor(today.diff(date2, "years").years);
    },
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";
      const date = DateTime.fromISO(isoDateString).setLocale("id");

      return date.monthLong + " " + date.year;
    },
    onPageChanged(e) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji " + this.tabSource[this.tabPanelIndex].text + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
